export default __webpack_public_path__ + "1ce88e89b8c87c75e610ef1ff8fa175c.svg";